import { useState } from 'react'

export const useLoadingMessage = () => {
  const [message, setMessage] = useState<string>()
  const [isLoading, setIsLoading] = useState(true)

  const updateLoader = (newIsLoading: boolean, newMessage?: string) => {
    setIsLoading(newIsLoading)
    setMessage(newMessage)
  }

  return { message, isLoading, updateLoader }
}
